import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";
import { StateName } from "./";
import { animated, useSpring } from "react-spring";

type DropBoxFieldProps = {
  isOver: boolean;
  state: StateName;
  stretch?: boolean;
};

export const dropBoxFieldCss = css`
  display: flex;
  position: relative;
  max-width: 100%;
  background-color: transparent;
  border: 2px solid ${select.color(["grey", 1])};
  border-radius: 5px;
  transition: ${select.speed("fast")};
  box-sizing: border-box;
  overflow: hidden;
`;

export const DropBoxField = styled.div<DropBoxFieldProps>`
  ${dropBoxFieldCss};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${select.space(2)} ${select.space(3)};
  width: ${p => (p.stretch ? "100%" : null)};

  ${p =>
    p.isOver &&
    css`
      * {
        pointer-events: none;
      }
    `}
`;

export const MainText = styled.div`
  display: block;
  margin-top: ${select.space(2)};
  text-align: center;
`;

type OpenFileBrowserTextProps = {
  state: StateName;
};

export const OpenFileBrowserText = styled.div<OpenFileBrowserTextProps>`
  display: block;
  transition: ${select.speed("slow")};

  ${p =>
    p.state === "ERROR" &&
    css`
      * {
        opacity: 0;
      }
    `}
`;

const OverlayBase = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: ${select.color(["grey", 0])};
  pointer-events: none;
  z-index: 1;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 90px;
`;

export const Overlay = (props: { children?: any }) => {
  const animationProps = useSpring({
    config: { duration: 250 },
    opacity: 1,
    from: { opacity: 0 }
  });

  const AnimatedOverlay = animated(OverlayBase);

  return (
    <AnimatedOverlay style={animationProps}>{props.children}</AnimatedOverlay>
  );
};
